import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'EmobilityPreview' })(theme => ({
	root: {
		textAlign: 'left',
		whiteSpace: 'nowrap',
		scrollBehavior: 'smooth',
		overflow: 'hidden',
		'&.static-mode': {
			textAlign: 'center'
		},
		'&.scroll-mode': {
			padding: '0 50% 0px 50%'
		}
	},
	tab: {
		display: 'inline-block',
		position: 'relative',
		cursor: 'pointer',
		textTransform: 'uppercase'
	},
	tabLine: {
		height: '1px',
		background: theme.palette.formControlLabel,
		width: '100%'
	},
	tabInner: {
		WebkitTouchCallout: 'none',
		WebkitUserSelect: 'none',
		KhtmlUserSelect: 'none',
		MozUserSelect: 'none',
		msUserSelect: 'none',
		userSelect: 'none',
		margin:' 0px 15px 0px 15px',
		'&.lastTab': {
			marginRight: 0
		},
		'&.firstTab': {
			marginLeft: 0
		}
	},
	label: {
		display: 'block',
		padding: '8px 5px 8px 5px',
		fontSize: '16px',
		fontWeight: 'bold',
		letterSpacing: '0.57px',
		lineHeight: 'normal',
		color: theme.palette.formControlLabel,
		'&.active': {
			color: theme.palette.text.primary
		}
	},
	indicator: {
		width: '100%',
		height: '3px',
		'&.active': {
			background: theme.palette.primary.main
		}
	}
}));
